<template>

			<!-- siteframe -->
	<div id="siteframe">
	<!-- content -->
		<div id="content">
		<div id="_page_content"><div class="column_100">
		<div id="main" min_height="400" style="; width: 100%"><div>
		<div class="hero-home">
		<div class="hero-content">
		<h1>Radiology Analytics at Your Fingertips</h1>
		<p style="color:white !important;">Infinitt Business Analytics does the heavy data analysis lifting for radiology practices, departments, and imaging centers providing you with fast and reliable operational and financial insight.</p>
		<img alt="Infinitt Business Analytics" class="responsive" src="/static/images/herographic-laptop-ipad.png" style="max-width: 700px;"></div>
		</div></div>


		<div>
		<div class="band bg-gray" style="background: #FFF; padding: 0;">
		<div class="band-content">
		<div class="column span-2 cta" style="background: #F3A627 url(/static/images/hero-radiology.png) center center no-repeat; background-size: cover;"><router-link to="/overview"><button class="ghostbutton">Overview</button></router-link></div>
		<div class="column span-2 cta" style="background: #F3A627 url(/static/images/hero-veincare.png) center center no-repeat; background-size: cover;"><router-link to="/features"><button class="ghostbutton">Features</button></router-link></div>
		</div>
		</div></div>


		<div>
		<div class="container center" style="margin-top: 40px;">
		<h3>Answers in a fraction of the time.</h3>
		<h2 style="max-width: 600px; margin: 0 auto; margin-bottom: 30px;">IBA offers you reliable, daily reports and dashboards from your RIS/PACS and billing data. We specialize in finding your data and giving you the tools to get answers.</h2>
		<p class="center"><a href="/#/free-demo/"><button class="button">Free Demo</button></a></p>
		<div class="column span-3">
		<div class="biobox padded"><img src="/static/images/chart-save.png" style="width: 200px;">
		<h3>Save Time</h3>
		<p>Use your time running your practice not looking for the data.</p>
		</div>
		</div>
		<div class="column span-3">
		<div class="biobox padded"><img src="/static/images/chart-measure.png" style="width: 200px;">
		<h3>Measure Performance</h3>
		<p>Watch your business trends and get alerts.</p>
		</div>
		</div>
		<div class="column span-3">
		<div class="biobox padded"><img src="/static/images/chart-answer.png" style="width: 200px;">
		<h3>Answer Questions</h3>
		<p>Slice and dice your data to get answers to your questions.</p>
		</div>
		</div>
		<div style="clear: both;">&nbsp;</div>
		</div></div>


		</div></div>
		<div style="clear: both;"></div>
		</div>		<div style="clear: both;"></div>
		</div>
		<!-- end content -->
		<overview></overview>
		<features></features>
	</div>
			<!--  end siteframe -->

	

</template>

<style>
#content{
	padding:0;
}
</style>


<script>
    import {EventBus} from '../event-bus.js'
		import swal from 'sweetalert2'
		import overview from './Overview.vue'
		import features from './Features.vue'

    export default {
        name: 'home',
        data () {
            return {
               
            }
        },
        mounted(){

            
		},
		components:{
			overview: overview,
			features: features
		},
        methods:{
            showNoty: function(){
                EventBus.$emit('noty', {type:'success',msg:'hurray!'});
            },
            quote: function(){
                    $.get('http://quotes.rest/qod.json', function(res){
                        swal({
                            title: 'Quote of the Day: '+moment().format("L"),
                            html: res.contents.quotes[0].quote + "<br><br> -" + res.contents.quotes[0].author,
                            type: 'success'     
                        })
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/js/components/Home.vue